<template>
    <form>
        <div class="bet-name">
            <span>{{'random_system' | translate }}</span>
        </div>
        <div id="bet-area">
        <input      v-model="bettingSvc.random"
                    id="random"
                    type="number"
                    v-random-system-validator
                    @keydown="checkChars"
                    @keydown.enter.prevent="setFocus()"
                    @keydown.tab.prevent="setFocus()"
                    @click="setFocus('random')"
                    :disabled="isBettingDisabled"
            >
        </div>
        <div class="bet-name">
            <span>{{'system_bet' | translate }}</span>
        </div>
        <div>
            <input id="system"
                   type="number"
                   v-model="bettingSvc.system"
                   v-system-bet-validator
                   @keydown.enter.prevent="setFocus()"
                   @keydown.tab.prevent="setFocus()"
                   @click="setFocus('system')"
                   :disabled="isBettingDisabled"
            >
            <label v-if="bettingSvc.random && bettingSvc.random > 1 ">
                <span>/</span>
                <span>{{bettingSvc.random}}</span>
            </label>
            <label v-if="!bettingSvc.random || bettingSvc.random <= 1">
                <span>{{ 'system_no_combinations' | translate}}</span>
            </label>
        </div>
    </form>
</template>

<script>

    import {BettingSvc} from '../../../services/betting.service';
    import {RandomSystemValidator} from '../../../directives/randomsystem_validator';
    import {SystemBetValidator} from '../../../directives/systembet_validator';
    import {EventBus}   from '../../../utilities/event.bus';
    import {random} from'../../../utilities/random';
    import {invalidChars} from '../../../utilities/invalidCharsChecker';
    import {translate} from '../../../filters/translate';
    import {GameSvc} from '../../../services/game.service';

    let randomBet;
    let systemBet;

    export default {
        name: 'RandomSystemBet',

        filters: {
            translate,
        },

        directives: {
            RandomSystemValidator,
            SystemBetValidator,
        },

        data() {
            return {
                bettingSvc : BettingSvc.getBettingSvc(),
                random_system : 'random_system',
                system_bet : 'system_bet'
            }
        },
        computed: {
            isBettingDisabled () {
                return GameSvc.getGameSvc().gameInfo.betsBlocked;
            }
        },

        mounted(){

            randomBet =  document.getElementById('random') || '';
            systemBet =  document.getElementById('system') || '';
            this.bettingSvc.clearAll();
            this.bettingSvc.type = 'system';
            this._subscribeEvents();
            this.setFocus();

        },

        destroyed(){
            this._unsubscribeEvents();
        },

        methods: {
            checkChars(event) {
                invalidChars(event)
            },


            /**
             * Seto focus on right input
             * @param {String} type
             * @param {Object} e
             */

            setFocus(e,type) {

                if(!randomBet) return;

                if(type){
                    systemBet.focus();
                    return;
                }

                // if no value in random input set focus on it
                if(!randomBet.value){
                    randomBet.focus();
                    return;
                }

                //create random values
                if(randomBet.value){
                    this.bettingSvc.ticket.input = random(randomBet.value,1,80);
                }

                // set focus on system bet
                if(randomBet.value && !systemBet.value){
                    systemBet.focus();
                }

                //if future bet is active set focus on it
                if(systemBet.value && document.getElementById('future')){
                    document.getElementById('future').select();
                }



                if(systemBet.value && !document.getElementById('future')){
                    try {
                        BettingSvc.getBettingSvc().finalizeTicket();
                    } catch (err) {
                        return;
                    }

                    // reset
                    EventBus.$emit('keydown', {
                        key : '+'
                    })
                }

            },

            /**
             * Subscribe events
             * @private
             */

            _subscribeEvents(){

                EventBus.$on('Keno.FutureBetValid', () => {
                    try {
                        BettingSvc.getBettingSvc().finalizeTicket();
                    } catch (err) {
                        return;
                    }
                    this.resetAll();
                });

            },

            /**
             * Reset betting service and activate normal bet
             */

            resetAll() {
                this.bettingSvc.clearAll();
                EventBus.$emit('keydown',{
                    key : '+'
                });

            },

            /**
             * Unsubscribe events
             * @private
             */

            _unsubscribeEvents(){
                EventBus.$off('Keno.FutureBetValid');
            }
        }
    };

</script>

<style  lang="scss">
    @import '../../../assets/style/shop/betting';
</style>



// WEBPACK FOOTER //
// RandomSystem.vue?1d243ff8